import { AbstractControl, FormArray, FormControl, FormGroup } from '@angular/forms';

export function setDisabledState(shouldDisable: boolean, controls: (AbstractControl | null)[]) {
  controls.forEach(control => {
    if (control && control.disabled !== shouldDisable) {
      shouldDisable ? control.disable() : control.enable();
    }
  });
}

export function updateDescendantsValueAndValidity(formItem: FormArray | FormGroup) {
  if (formItem instanceof FormArray) {
    formItem.controls.forEach(abstractControl => {
      const formGroup = abstractControl as FormGroup;
      Object.keys((formGroup as FormGroup).controls).forEach(key =>
        (formGroup.get(key) as FormControl).updateValueAndValidity()
      );
    });
  } else if (formItem instanceof FormGroup) {
    Object.keys(formItem.controls).forEach(key =>
      (formItem.get(key) as FormControl).updateValueAndValidity()
    );
  }
}
